// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1i8Sw","filesListContainer":"PosDisputesFiles_filesListContainer__12nfT","filesButton":"PosDisputesFiles_filesButton__abldo"};